import { Attempt, Product, Quiz } from "@sabyr-dev/mist_elibrary/datasource";
import { Config } from "../../app";

export function getCookie(): string | undefined {
	const config = getConfig();
	return document.cookie.split(';')
		.map(cookie => cookie.split('=').map(part => part.trim()))
		.map(([key, value]) => ({ key, value }))
		.find(cookie => cookie.key == config.contentCookie)
		?.value;
}

export function getMode(): Product | undefined {
	const pattern: RegExp = /practicequestion\/(?<type>products|test|result)\/(?:v\/)?(?<sku>[-\w.~%!$&'()*+,;=:@]+)(?:\/(?<attempt>\d+))?/;
	const url: URL = new URL(window.location.href);
	const result: RegExpExecArray = pattern.exec(url.pathname);
	return result ? result.groups['type'] : undefined;
}

export function getProductId(): Product | undefined {
	const pattern: RegExp = /practicequestion\/(?<type>products|test|result)\/(?:v\/)?(?<sku>[-\w.~%!$&'()*+,;=:@]+)(?:\/(?<attempt>\d+))?/;
	const url: URL = new URL(window.location.href);
	const result: RegExpExecArray = pattern.exec(url.pathname);
	return result ? result.groups['sku'] : undefined;
}

export function getAttemptId(): Attempt | undefined {
	const pattern: RegExp = /practicequestion\/(?<type>products|test|result)\/(?:v\/)?(?<sku>[-\w.~%!$&'()*+,;=:@]+)(?:\/(?<attempt>\d+))?/;
	const url: URL = new URL(window.location.href);
	const result: RegExpExecArray = pattern.exec(url.pathname);
	if (result) {
		const value = parseInt(result.groups['attempt']);
		if (!Number.isNaN(value)) {
			return value;
		}
	}
	return undefined;
}

export function getConfig(): Config {
	// @ts-ignore
	return AppConfig;
}

export function getTestId(): Quiz | undefined {
	// @ts-ignore
	return testId;
}

export function getTestName(): string {
	return document.querySelector('ol > li > h3')?.textContent
		?? 'Practice Test';
}

export function getStarted(): Date {
	// @ts-ignore
	return started ? new Date(started) : new Date();
}
interface ServerAttempt {
	id: number;
	set_id: string[];
	test_id: string;
	name: string;
	started: string;
	finished: string;
	timed: boolean;
	answers: {
		id: string,
		content_sku: string,
		set_id: string,
		answer?: string,
		correct?: boolean
	}[];
	complete: boolean;
}

export function getServerAttempts(): ServerAttempt[] {
	// @ts-ignore
	return attempts;
}
